import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, CalendarCheck, MessageCircle, Pill, CreditCard, TestTube, CheckCircle2 } from 'lucide-react';
import { mockNotifications } from '../data/mockData';
export function NotificationsScreen() {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState(mockNotifications);
  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({
      ...n,
      read: true
    })));
  };
  const getIcon = (type: string) => {
    switch (type) {
      case 'booking':
        return <CalendarCheck className="w-5 h-5 text-blue-600" data-id="element-1053" />;
      case 'message':
        return <MessageCircle className="w-5 h-5 text-blue-600" data-id="element-1054" />;
      case 'prescription':
        return <Pill className="w-5 h-5 text-purple-600" data-id="element-1055" />;
      case 'payment':
        return <CreditCard className="w-5 h-5 text-green-600" data-id="element-1056" />;
      case 'lab':
        return <TestTube className="w-5 h-5 text-teal-600" data-id="element-1057" />;
      default:
        return <CalendarCheck className="w-5 h-5 text-slate-600" data-id="element-1058" />;
    }
  };
  const getIconBg = (type: string) => {
    switch (type) {
      case 'booking':
        return 'bg-blue-100';
      case 'message':
        return 'bg-blue-100';
      case 'prescription':
        return 'bg-purple-100';
      case 'payment':
        return 'bg-green-100';
      case 'lab':
        return 'bg-teal-100';
      default:
        return 'bg-slate-100';
    }
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="flex flex-col min-h-screen bg-slate-50" data-id="element-1059">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10 flex items-center justify-between" data-id="element-1060">
        <div className="flex items-center gap-3" data-id="element-1061">
          <button onClick={() => navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-1062">
            <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-1063" />
          </button>
          <h1 className="text-xl font-bold text-slate-900" data-id="element-1064">Notifications</h1>
        </div>
        <button onClick={markAllAsRead} className="text-sm font-medium text-blue-600 hover:text-blue-700 flex items-center gap-1" data-id="element-1065">
          <CheckCircle2 className="w-4 h-4" data-id="element-1066" />
          Mark all read
        </button>
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-1067">
        <div className="space-y-4" data-id="element-1068">
          {notifications.map(notification => <div key={notification.id} className={`p-4 rounded-2xl flex gap-4 transition-colors ${notification.read ? 'bg-white border border-slate-100' : 'bg-blue-50/50 border border-blue-100'}`} data-id="element-1069">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${getIconBg(notification.type)}`} data-id="element-1070">
                {getIcon(notification.type)}
              </div>
              <div className="flex-1" data-id="element-1071">
                <div className="flex justify-between items-start mb-1" data-id="element-1072">
                  <h3 className={`font-semibold text-sm ${notification.read ? 'text-slate-900' : 'text-blue-900'}`} data-id="element-1073">
                    {notification.title}
                  </h3>
                  <span className="text-xs text-slate-500 whitespace-nowrap ml-2" data-id="element-1074">
                    {notification.time}
                  </span>
                </div>
                <p className={`text-sm ${notification.read ? 'text-slate-500' : 'text-slate-700'}`} data-id="element-1075">
                  {notification.description}
                </p>
              </div>
              {!notification.read && <div className="w-2 h-2 rounded-full bg-blue-600 mt-2 shrink-0" data-id="element-1076" />}
            </div>)}
        </div>
      </div>
    </motion.div>;
}